import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageContainer } from '@/components/templates/PageContainer';
import { PageHeaderSkeleton, SettingsTabsSkeleton } from '@/components/molecules/skeletons';

const RightSidebarSkeleton = (
  <div className="sticky top-20 w-40 h-[600px]">
    <Skeleton className="h-full w-full rounded-xl" />
  </div>
);

export const SettingsPageSkeleton = memo(() => {
  return (
    <PageContainer rightSidebar={RightSidebarSkeleton}>
      <div className="space-y-6">
        <PageHeaderSkeleton />
        <SettingsTabsSkeleton />
        <div className="bg-card border border-border rounded-xl shadow-none p-6">
          <Skeleton className="h-48 w-full rounded-lg" />
        </div>
      </div>
    </PageContainer>
  );
});

SettingsPageSkeleton.displayName = 'SettingsPageSkeleton';
